<template>
  <v-container class="help-content">
    <v-row dense>
      <v-col cols="7">
        <v-img src="images/instruct5.png" />
      </v-col>
      <v-col>
        <v-row dense>
          <v-col cols="1"></v-col>
            <v-col>
              <v-row dense>
                <v-col cols="1">
                  1.
                </v-col>
                <v-col>
                  {{ $t("Helps.instruct-control-3") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  2.
                </v-col>
                <v-col>
                  {{ $t("Helps.instruct-control-4") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  3.
                </v-col>
                <v-col>
                  {{ $t("Helps.instruct-control-5") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  4.
                </v-col>
                <v-col>
                  {{ $t("Helps.instruct-control-6") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1"></v-col>
                <v-col>{{ $t("Helps.instruct-control-6-1") }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1"></v-col>
                <v-col>{{ $t("Helps.instruct-control-6-2") }}</v-col>
              </v-row>
            </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </v-col> 
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style></style>
